import {
  TextField,
  OutlinedTextFieldProps,
  InputAdornment,
  Icon
} from '@mui/material';

interface InputWithIconProps extends Omit<OutlinedTextFieldProps, 'variant'> {
  icon: string,
}

const InputWithIcon = ({ icon, ...props }: InputWithIconProps) => {
  return (
    <TextField
      fullWidth={true}
      variant={'outlined'}
      InputProps={{
        startAdornment: (<InputAdornment position="start" sx={{ borderRadius: 0 }}>
          <Icon sx={{ borderRadius: 0 }}>{icon}</Icon>
        </InputAdornment>),
      }}
      {...props}
    />
  );
};

export default InputWithIcon;